<template>
  <v-data-table
    :headers="serviceHeaders"
    :items="dataservice"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    :search="searchservice"
    item-key="id_service_restaurant"
    show-expand
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        class="mt-5"
      >
        <v-toolbar-title>Data Service  {{ restaurant.restaurant_name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchservice"
          solo
          dense
          append-icon="mdi-magnify"
          :label="'Search Service '+restaurant.restaurant_name"
          class="mr-3 white"
          outlined
          hide-details
        />
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-row>
          <v-col>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>Notes</td>
                  <td>{{ item.note }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </td>
    </template>
    <template #[`item.cost_for_child`]="{ item }">
      Rp. {{ Number(item.cost_for_child).toLocaleString() }}
    </template>
    <template #[`item.cost_for_adult`]="{ item }">
      Rp. {{ Number(item.cost_for_adult).toLocaleString() }}
    </template>
    <template #[`item.actions`]="{ item }">
      <v-btn
        small
        class="mr-2 text-capitalize primary"
        @click="UseService(item)"
      >
        Use Service
        <v-icon>{{ icons.mdiPlus }}</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
} from '@mdi/js'
import axios from 'axios'

export default {
  props: ['restaurant'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
      },
      modal1: false,
      modal2: false,
      dialog: false,
      dialog3: false,
      searchservice: '',
      expanded: [],
      editedIndex: -1,
      singleExpand: true,
      serviceHeaders: [
        { text: 'Service Name', value: 'service_name' },
        { text: 'Cost For Adult', value: 'cost_for_adult' },
        { text: 'Cost For Child', value: 'cost_for_child' },
        { text: 'Detail Service', value: 'detail_service' },

        {
          text: 'Actions', value: 'actions', sortable: false, width: 200,
        },
      ],
      record: {
        detail_service: '',
        cost: '',
        note: '',
      },
      formservice: {
        service_name: '',
        id_restaurant: this.restaurant.id_restaurant,
        details: [],
      },
      dataservice: [],
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Service ' : 'Edit Service Restaurant'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Restaurant' : 'Update Restaurant'
    },
  },
  watch: {
    restaurant(newVal, oldVal) {
      if (newVal.id_restaurant !== oldVal.id_restaurant) {
        this.initialize()
      }
    },
  },
  mounted() {
    this.initialize()
  },
  methods: {
    UseService(item) {
      this.$root.$emit('MakeItinerary', item, 'Restaurant')
    },
    DeleteService(index) {
      this.formservice.details.splice(this.formservice.details.indexOf(index), 1)
    },
    AddRecord() {
      this.formservice.details.push(this.record)
      this.record = {
        detail_service: '',
        cost: '',
        note: '',
      }
    },
    CekDialog() {
      this.formservice = {
        service_name: '',
        id_restaurant: this.restaurant.id_restaurant,
        details: [],
      }
      this.dialog3 = false
    },
    editItem(item) {
      this.editedIndex = this.dataservice.indexOf(item)
      this.formservice.service_name = item.service_name
      this.formservice.id_restaurant = item.id_restaurant
      this.formservice.details = item.details
      this.dialog3 = true
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getServiceRestaurant', { id_restaurant: this.restaurant.id_restaurant }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.dataservice = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteServiceRestaurant', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveServiceRestaurant', this.formservice).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.dialog3 = false
        this.CekDialog()
        this.editedIndex = -1
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
